export default "__VITE_ASSET__9LRYSO4H__"